// Translation for ar
export const ar = {
        common: {
            save: 'حفظ',
            cancel: 'إلغاء',
            close: 'إغلاق',
            delete: 'حذف',
            edit: 'تعديل',
            activate: 'تفعيل',
            add: 'إضافة',
            saving: 'جاري الحفظ...',
            loading: 'جاري التحميل...',
            active: 'نشط',
            inUse: 'قيد الاستخدام',
            test: 'اختبار',
            searchApps: 'البحث عن التطبيقات...',
            betaBanner: 'بيتا - الخدمة غير متوفرة بعد!'
        },
        header: {
            creditBalance: 'الرصيد',
            minutes: 'دقيقة'
        },
        auth: {
            signIn: 'تسجيل الدخول',
            signUp: 'تسجيل',
            username: 'اسم المستخدم',
            password: 'كلمة المرور',
            continue: 'متابعة',
            noAccount: 'ليس لديك حساب؟',
            hasAccount: 'هل لديك حساب بالفعل؟',
            loginError: 'فشل تسجيل الدخول',
            invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صالحة',
            rateLimited: 'محاولات تسجيل دخول كثيرة جداً. يرجى الانتظار لحظة.',
            sessionExpired: 'انتهت صلاحية جلستك. يرجى استخدام رابط سحري جديد.',
            magicLinkInvalid: 'رابط تسجيل الدخول غير صالح أو منتهي الصلاحية.',
            magicLinkSuccess: 'مرحباً! تم تسجيل دخولك بنجاح.',
            magicLinkProcessing: 'جاري معالجة تسجيل الدخول...',
            connectionError: 'خطأ في الاتصال. يرجى المحاولة مرة أخرى.'
        },
        profile: {
            myProgress: 'تقدم التعلم الخاص بي',
            signOut: 'تسجيل الخروج',
            plan: 'الخطة: '
        },
        settings: {
            title: 'الإعدادات',
            tabs: {
                uiSettings: 'إعدادات الواجهة',
                systemPrompt: 'موجه النظام',
                llmProfiles: 'ملفات LLM',
                ttsProfiles: 'ملفات TTS',
                language: 'اللغة',
            },
            uiSettings: {
                title: 'واجهة المستخدم',
                themeMode: 'وضع السمة',
                darkMode: 'الوضع الداكن',
                lightMode: 'الوضع الفاتح',
                themeColor: 'لون السمة',
                themeColorDesc: 'اختر لون التمييز للأزرار والأيقونات والإبرازات',
                background: 'الخلفية',
                backgroundDesc: 'اختر خلفية لمساحة العمل الخاصة بك',
                selectBackgroundColor: 'اختر لون الخلفية',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'التركيز',
                    concentration: 'التركيز العميق',
                    relaxation: 'الاسترخاء',
                    lianas: 'النباتات المتسلقة',
                    color: 'لون'
                },
                backgroundColors: {
                    deepDark: 'داكن عميق',
                    darkGrey: 'رمادي داكن',
                    midnightBlue: 'أزرق منتصف الليل',
                    indigo: 'نيلي',
                    darkTeal: 'أزرق مخضر داكن',
                    brown: 'بني',
                    darkRed: 'أحمر داكن',
                    deepPurple: 'أرجواني عميق',
                    pureWhite: 'أبيض نقي',
                    softWhite: 'أبيض ناعم',
                    lightGrey: 'رمادي فاتح',
                    paleBlue: 'أزرق شاحب',
                    paleGreen: 'أخضر شاحب',
                    paleOrange: 'برتقالي شاحب',
                    lavender: 'لافندر',
                    blueGrey: 'رمادي مزرق'
                }
            },
            systemPrompt: {
                label: 'موجه النظام:',
                placeholder: 'جاري تحميل موجه النظام...',
                emptyError: 'لا يمكن أن يكون موجه النظام فارغًا!',
                saveSuccess: '✓ تم حفظ موجه النظام بنجاح!',
                loadError: 'خطأ في تحميل موجه النظام',
                saveError: 'خطأ في الحفظ'
            },
            llmProfiles: {
                addButton: '+ إضافة اتصال جديد',
                newConnection: 'اتصال جديد',
                editConnection: 'تعديل الاتصال',
                emptyState: 'لا توجد اتصالات LLM متاحة. انقر أدناه لإضافة واحد.',
                loadingProfiles: 'جاري تحميل الملفات الشخصية...',
                nameLabel: 'الاسم *',
                namePlaceholder: 'مثال: OpenAI GPT-4',
                apiUrlLabel: 'رابط API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'مفتاح API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'النموذج *',
                modelPlaceholder: 'gpt-4, mistral-tiny, إلخ.',
                allFieldsRequired: 'يجب ملء جميع الحقول!',
                saveSuccess: '✓ تم حفظ الملف الشخصي بنجاح!',
                deleteConfirm: 'هل تريد حقًا حذف "{name}"؟',
                profileNotFound: 'الملف الشخصي غير موجود!',
                loadError: 'خطأ في تحميل الملفات الشخصية',
                saveError: 'خطأ في الحفظ',
                activateError: 'خطأ في التفعيل',
                deleteError: 'خطأ في الحذف',
                modelInfo: 'النموذج: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ إضافة صوت جديد',
                newVoice: 'صوت جديد',
                editVoice: 'تعديل الصوت',
                emptyState: 'لا توجد ملفات TTS متاحة. انقر أدناه لإضافة واحد.',
                loadingProfiles: 'جاري تحميل ملفات TTS...',
                nameLabel: 'الاسم',
                namePlaceholder: 'مثال: ElevenLabs Adam الخاص بي',
                providerLabel: 'المزود',
                providerPlaceholder: 'مثال: ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (محلي)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'رابط API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'مفتاح API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'معرف النموذج *',
                modelIdPlaceholder: 'مثال: eleven_monolingual_v1',
                voiceIdLabel: 'معرف الصوت',
                voiceIdPlaceholder: 'مثال: pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'يجب ملء جميع الحقول!',
                saveSuccess: '✓ تم حفظ ملف TTS بنجاح!',
                deleteConfirm: 'هل تريد حقًا حذف "{name}"؟',
                loadError: 'خطأ في تحميل ملفات TTS',
                saveError: 'خطأ في الحفظ',
                activateError: 'خطأ في التفعيل',
                deleteError: 'خطأ في الحذف'
            },
            language: {
                title: 'اختر اللغة',
                description: 'حدد اللغة المفضلة لديك لواجهة المستخدم'
            },
        },
        chat: {
            ready: 'جاهز',
            start: 'ابدأ',
            stop: 'توقف',
            initialMessage: 'انقر على ابدأ للمحادثة في الوقت الفعلي.',
            listening: 'يستمع...',
            speaking: 'ثورستن يتحدث...',
            userLabel: 'أنت',
            aiLabel: 'الذكاء الاصطناعي',
            modalTitle: 'Thorsten AI دردشة',
            inputPlaceholder: 'اكتب رسالة...',
            send: 'إرسال',
            loginRequired: 'يرجى تسجيل الدخول لاستخدام هذه الخدمة.',
            loginButton: 'سجل الدخول الآن',
            magicLinkRequired: 'يرجى استخدام رابط سحري لتسجيل الدخول.',
            creditLimitError: 'لقد نفدت حصتك الساعية. يرجى ترقية خطتك (Medium/Premium) للمتابعة.',
            serviceDisabled: 'خدمة الدردشة غير متوفرة حالياً. يرجى المحاولة مرة أخرى لاحقاً.'
        },
        notifications: {
            error: 'خطأ',
            success: 'نجح',
            info: 'معلومات',
            unknownError: 'حدث خطأ غير معروف'
        },
        cookie: {
            message: 'يستخدم هذا الموقع ملفات تعريف الارتباط لتزويدك بأفضل تجربة مستخدم ممكنة.',
            accept: 'موافق'
        },
        curriculum: {
                buttonLabel: 'المنهج الدراسي',
                buttonTitle: 'عرض محتوى المنهج الدراسي',
                modalTitle: 'منهج {app} الدراسي',
                sections: {
                    topic: 'موضوع المنهج الدراسي',
                    explanation: 'شرح مناسب للأطفال',
                    chat: 'اسأل الذكاء الاصطناعي',
                    studentProfile: 'ملف الطالب'
                },
                chat: {
                    hint: 'اطرح سؤالاً حول موضوع المنهج. سيساعدك الذكاء الاصطناعي على فهم سبب أهمية هذا الموضوع.',
                    placeholder: 'اكتب سؤالك …',
                    inputAria: 'سؤال للذكاء الاصطناعي',
                    send: 'إرسال',
                    sending: 'جارٍ الإرسال …',
                    empty: 'لم يقدم الذكاء الاصطناعي إجابة. يُرجى المحاولة مرة أخرى.',
                    noTopic: 'لا يوجد محتوى منهج متاح لطرح الأسئلة عليه.',
                    requestFailed: 'تعذّر إنشاء الرد.'
                },
                topic: {
                    empty: 'لا يوجد موضوع منهج دراسي مرتبط بهذا التطبيق الصغير في النظام الخلفي.',
                    missingDetail: 'بيانات المنهج الدراسي التفصيلية لهذا التطبيق الصغير غير متوفرة بعد في النظام الخلفي.',
                    learningGoals: 'أهداف التعلم',
                    prerequisites: 'المتطلبات الأساسية',
                    unitLabel: 'الوحدة',
                    durationLabel: 'المدة',
                    difficultyLabel: 'الصعوبة',
                    hours: 'ساعة',
                    minutes: 'دقيقة'
                },
                explanation: {
                    empty: 'لا يوجد شرح مناسب للأطفال متاح.',
                    loadingPrepare: 'الذكاء الاصطناعي يعد الشرح',
                    loadingExplain: 'الذكاء الاصطناعي يشرح الموضوع بلغة مناسبة للأطفال',
                    requestFailed: 'تعذر إنشاء شرح مناسب للأطفال.'
                },
                studentProfile: {
                    country: 'الدولة',
                    region: 'الولاية / المنطقة',
                    schoolType: 'نوع المدرسة',
                    grade: 'الصف',
                    noContext: 'لا يوجد سياق طالب متاح.',
                    childProfileNotFound: 'لم يتم العثور على ملف طالب في النظام الخلفي لتسجيل الدخول الحالي.',
                    loginProfileIncomplete: 'ملف تسجيل الدخول لا يحتوي بعد على سياق طالب كامل.',
                    educationContextNotFound: 'تم العثور على ملف طالب، ولكن لم يتم تعيين منهج دراسي.',
                    noToken: 'لم يتم العثور على طالب مسجل الدخول.'
                },
                errors: {
                    signInRequired: 'يرجى تسجيل الدخول لعرض المنهج الدراسي.',
                    appIdMissing: 'معرف التطبيق مفقود.',
                    loadFailed: 'تعذر تحميل بيانات المنهج الدراسي.'
                }
            }
    };
